import React, { useState, useContext } from 'react'
import { IonCard, IonToggle, IonItem, IonLabel } from '@ionic/react'
import { ConfigContext } from '../../contexts/ConfigContext';

const GST = () => {
    const { Config, setConfig } = useContext(ConfigContext);
    const [gst, setGst] = useState(Config.gst.enabled)
    const [inclusive, setInclusive] = useState(Config.gst.inclusive)
    const [whatsapp, setwhatsapp] = useState(Config.whatsapp);

    const GSTtoggle = (e) => {
        // console.log(e);
        Config.gst.enabled = e;
        setConfig(Config);
    }
    const Whatsapptoggle = (e) => {
        // console.log(e);
        Config.whatsapp = e;
        setwhatsapp(e)
        setConfig(Config);
    }
    const GSTInclusivetoggle = (e) => {
        // console.log(e);
        Config.gst.inclusive = e;
        setConfig(Config);
    }
    return (
        <IonCard>
            <IonItem class=''>
                <IonToggle checked={gst} onIonChange={() => {
                    setGst(!gst)
                    GSTtoggle(!gst)
                }} />
                <IonLabel>GST Enabled</IonLabel>
            </IonItem>

            <IonItem hidden={!gst} class='ion-padding-start subOpt'>
                <IonToggle checked={inclusive} onIonChange={() => {
                    setInclusive(!inclusive);
                    GSTInclusivetoggle(!inclusive);
                }} />
                <IonLabel>{inclusive ? "GST Price Inclusive" : "GST Price Exclusive"}</IonLabel>
            </IonItem>

            <IonItem class=''>
                <IonToggle checked={whatsapp} onIonChange={() => {
                    Whatsapptoggle(!whatsapp)
                }} />
                <IonLabel>WhatsApp Bill Send</IonLabel>
            </IonItem>
        </IonCard>
    )
}

export default GST
